enum BarcodeDetectDialogFields {
	OUTPUT = "output",
	FORMAT = "format",
	PAGERANGE = "pagerange",
	CONTENT_LENGTH = "content_length",
	PURE = "pure",
	GS1 = "gs1",
	CHECK_DIGIT = "check_digit",
	START_END_DIGITS = "start_end_digits",
	EXTENSION = "extension"
}

export default BarcodeDetectDialogFields;